import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import StoryPage from './components/StoryPage';
import './App.css';

export default function App() {
  const [view, setView] = useState('landing');
  const [userData, setUserData] = useState(null);

  const handleGenerate = (data) => {
    setUserData(data);
    setView('story');
  };

  const handleBack = () => {
    setView('landing');
    setUserData(null);
  };

  return (
    <div className="app">
      {view === 'landing' && <LandingPage onGenerate={handleGenerate} />}
      {view === 'story' && <StoryPage data={userData} onBack={handleBack} />}
    </div>
  );
}
